module.exports = __webpack_public_path__ + "img/farm.811aeb34.png";